<template>
    <el-dialog
        title="绑定主题"
        :visible.sync="dialogVisible"
        center
        :close-on-click-modal="false"
        custom-class="custom-dialog">
        <div class="dialog-content">
            <el-form :model="formData" ref="formData">
                <el-form-item prop="name" label="主题名称:" :rules="[{required: true, message: '请选择主题'}]">
                    <!-- <el-select 
                        v-model="tourItem" 
                        filterable 
                        remote
                        placeholder="请输入主题名称"
                        :remote-method="searchTour"
                        :loading="searchLoading"
                        size="medium"
                        @change="selectTour"
                        value-key="id">
                        <el-option
                            v-for="item in tourList"
                            :key="item.id"
                            :label="item.name"
                            :value="item">
                        </el-option>
                    </el-select> -->
                    <el-autocomplete
                        v-model="formData.name"
                        :fetch-suggestions="searchTour"
                        placeholder="请输入主题名称"
                        @select="selectTour"
                        :trigger-on-focus="false"
                        size="medium"
                        style="width:100%"
                        ref="searchInput"
                        >
                        <template slot-scope="{ item }">
                            <template v-if="noData">
                                没有找到相关数据
                            </template>
                            <div class="name" v-else>{{ item.name }}</div>
                        </template>
                    </el-autocomplete>
                </el-form-item>
            </el-form>
            
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="bindEvent">确认绑定</el-button>
        </span>
    </el-dialog>
</template>

<script>
const defaultFormData = {
    tourId:'',
    name:'',
    type:2
}
export default {
    props:{
        activityIds:{
            type:Array,
            default: () => []
        }
    },
    data(){
        return{
            dialogVisible: false,
            formData:{
                ...defaultFormData
            },
            tourList:[],
            searchLoading:false,
            btnLoading:false,
            tourItem:null,
            noData: false,
            word:''
        }
    },
    methods:{
        show(){
            this.dialogVisible = true
        },
        close(){
            this.formData = { ...defaultFormData };
            this.$refs.formData && this.$refs.formData.resetFields();
            this.tourItem = null;
            this.dialogVisible = false
        },
        //搜索主题
        searchTour(query,cb){
            if(query != ""){
                this.word = query;
                this.searchLoading = true;
                this.noData = false;
                this.$request({
                    url: '/theme/manger/list',
                    method: 'POST',
                    data: {value:query,type:2,pageNo:1,pageSize:50}
                }).then(res => {
                    const { state, result } = res.data;
                    if( state == 1){
                        if(result && result.result.length > 0){
                            this.tourList = result.result;
                            cb(this.tourList);
                        }else{
                            this.tourList = [];
                            this.formData.tourId = '';
                            this.formData.name = query;
                            this.noData = true;
                            cb([this.noData]);
                        }
                    }
                    
                }).catch( () => {
                    this.tourList = [];
                    this.formData.tourId = '';
                    this.formData.name = query;
                    this.noData = true;
                    cb([this.noData]);
                }).finally(() => {
                    this.searchLoading = false;
                });
            }
        },
        //选择主题
        selectTour(e){
            if(this.noData){
                this.formData.name = this.word
            }else{
                this.formData.tourId = e.id;
                this.formData.name = e.name;
            }
        },
        //绑定主题
        bindEvent(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/activity/saveTourTheme',
                        data: {...this.formData,activityIds:this.activityIds},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$message.success("绑定成功");
                                this.close();
                                this.$emit('onUpdate');
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else{
                    return false;
                }
            });   
            
        }
    }
}
</script>
<style lang="scss" scoped>

</style>